import CorsWorker from "../utils/CorsWorker";

const WORKER_BASE_URL = process.env.WORKER_URL;

const schedulingTimelineWorkerInstance = ((): {
  getWorker: () => Worker;
  killWorker: () => void;
} => {
  let instance: Worker | undefined;

  function createInstance(): Worker {
    const worker = new CorsWorker(
      new URL(
        `${WORKER_BASE_URL}/schedulingTimelineItemWorker.js`,
        import.meta.url,
      ),
    ).getWorker();

    return worker;
  }

  return {
    getWorker(): Worker {
      instance ??= createInstance();
      return instance;
    },
    killWorker(): void {
      instance?.terminate();
      instance = undefined;
    },
  };
})();

export default schedulingTimelineWorkerInstance;
